<div class="container-fluid" >
    <mat-form-field >
        <input matInput [matDatepicker]="mmyyPicker" 
            attr.data-test-input-type="inputType" (dateChange)="onDateChange()" (blur)="onDateChange()"
            [min]="minDate" [max]="maxDate" [formControl]="dateValue" appMrasMaskDate2 [disabled]="summaryMode"
            [readonly]="summaryMode">
            <mat-hint>MM/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="mmyyPicker"></mat-datepicker-toggle>
        <mat-datepicker #mmyyPicker startView="year" (monthSelected)="setMonthAndYear($event, mmyyPicker)" [disabled]="summaryMode"></mat-datepicker>
        <mat-error *ngIf="dateValue.hasError('matDatepickerMin')">Minimum value is {{minDate}}</mat-error>
        <mat-error *ngIf="dateValue.hasError('matDatepickerMax')">Maximum value is {{maxDate}}</mat-error>        
        <mat-error *ngIf="question.invalid">required</mat-error>
    </mat-form-field>

</div>